import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { Select } from '../Forms/Select';
import messages from './messages';

const BoxContainer = styled.div`
  ${tw`w-full bg-white rounded-20 py-big px-medium flex flex-col`}
  gap: var(--size-medium)
`;

const Title = styled.span`
  ${tw`font-bold text-p-large-m leading-p-large-m`}
`;
const SelectStyle = css`
  ${tw``}
  height: 45px;
  max-width: 180px;
  width: 100%;
`;

const BoxContent = styled.div`
  ${tw`flex flex-col items-center text-p-small sm:flex-row`}
  flex-wrap: wrap;
  gap: var(--size-small);
`;

type SelectOptions = Array<{
  value: string;
  children: ReactNode;
  isDisabled?: boolean;
}>;

type BoxProps = {
  firstSelectOptions: SelectOptions;
  secondSelectOptions: SelectOptions;
  secondSelectValue?: string;
  firstSelectValue?: string;
  secondSelectOnChange?: (value: string) => void;
  firstSelectOnChange?: (value: string) => void;
  middleMessage: ReactNode;
  title?: ReactNode;
};

const ComparisonBox = (props: BoxProps) => {
  const {
    firstSelectOnChange,
    firstSelectOptions,
    firstSelectValue,
    middleMessage,
    secondSelectOnChange,
    secondSelectOptions,
    secondSelectValue,
    title,
  } = props;

  return (
    <BoxContainer>
      <Title>{title ?? <FormattedMessage {...messages.bookingTrip} />}</Title>
      <BoxContent>
        <Select
          customStyle={SelectStyle}
          onChange={(event) => firstSelectOnChange(event.target.value)}
          value={firstSelectValue}
        >
          {firstSelectOptions.map((option, index) => (
            <option
              key={index}
              disabled={option.isDisabled}
              value={option.value}
            >
              {option.children}
            </option>
          ))}
        </Select>

        <span>{middleMessage}</span>

        <Select
          customStyle={SelectStyle}
          onChange={(event) => secondSelectOnChange(event.target.value)}
          value={secondSelectValue}
        >
          {secondSelectOptions.map((option, index) => (
            <option
              key={index}
              disabled={option.isDisabled}
              value={option.value}
            >
              {option.children}
            </option>
          ))}
        </Select>
      </BoxContent>
    </BoxContainer>
  );
};

export default ComparisonBox;
